import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

export default class HistoryDialog extends React.PureComponent {
  static propsTypes = {
    id: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  }

  listenHistoryChange = event => {
    window.history.pushState(null, null, location.href);

    window.onpopstate = () => {
      this.props.onClose();
    };
  }

  stopListeningHistoryChange = () => {
    window.onpopstate = () => {};
    this.normalizeNavigation();
  }

  normalizeNavigation() {
    window.history.go(1);
    window.history.go(-1);
  }

  render() {
    return (
      <Dialog
        onEntered={this.listenHistoryChange}
        onExit={this.stopListeningHistoryChange}
        {...this.props}
      >
        {this.props.children}
      </Dialog>
    );
  }
}
